module.exports = __webpack_public_path__ + "static/img/2_1_2.f8ae5e5b.jpg";